(ns url.install
  "Where Humble is installed from, per surface, and the guide that walks
   through it. Shared so these destinations live in one place rather than
   being pasted into every card, menu and onboarding step that links to them.

   Call sites that need attribution append their own `utm_*` query string.")

(def chrome-store-url
  "https://chromewebstore.google.com/detail/humble-ai/bieekfeiaebohcjnfemcklfjkejndijd")

(def setup-guide-url
  "https://humbleai.com/setup/")

(def mobile-setup-url
  "The setup guide opened at the section on putting Humble on a phone."
  (str setup-guide-url "#phone"))

(def chrome-store-url-from-home
  "`chrome-store-url` as linked from Humble Home — its menu, its integrations
   card and its setup steps all report the same source."
  (str chrome-store-url "?utm_source=humble-home"))
